import emailjs from "emailjs-com";
import { useRef, useState } from "react";
import "../styles/contactForm.css";
import { LuSendHorizontal } from "react-icons/lu";
import toast from "react-hot-toast";

export default function ContactForm() {
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    setLoading(true);
    e.preventDefault();

    emailjs
      .sendForm(
        "service_aapgr6b",
        "template_o55xeii",
        e.target,
        "rZE2hSd922Am4Vgv1"
      )
      .then(
        (result) => {
          toast.success("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          toast.error("Something went wrong. Try again later.");
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <form className="contact-form" ref={form} onSubmit={sendEmail}>
      <input
        className="contact-form__input"
        type="text"
        name="name"
        placeholder="Your Name"
        required
      />
      <input
        className="contact-form__input"
        type="email"
        name="email"
        placeholder="Your Email"
        required
      />
      <textarea
        className="contact-form__area"
        name="message"
        placeholder="Message"
        required
      />
      <button className="contact-form__submit" type="submit" disabled={loading}>
        <span> {loading ? "Sending..." : "Send"}</span>
        <LuSendHorizontal />
      </button>
    </form>
  );
}
